<!--
 * @Description: 月份选择器
 * @Author: mdb
 * @Date: 2023-03-15 16:54:02
 * @LastEditTime: 2023-03-15 18:14:22
 * @LastEditors: mdb
-->
<template>
  <a-date-picker
    v-model:value="modelValue"
    picker="month"
    :format="props.format"
    :valueFormat="valueFormat"
    :allowClear="props.allowClear"
    :placeholder="placeholder || t('common.pleaseSelect')"
    @change="handleChange"
  />
</template>

<script setup lang="ts">
import { PropType, ref, computed } from 'vue'
import dayjs, { Dayjs } from 'dayjs'
import { useI18n } from 'vue-i18n'
const { t } = useI18n()

const props = defineProps({
  startTime: {
    type: String as PropType<string>
  },
  endTime: {
    type: String as PropType<string>
  },
  format: {
    type: String as PropType<string>,
    default: 'YYYY-MM'
  },
  valueFormat: {
    type: String as PropType<string>,
    default: 'YYYY/MM/DD HH:mm:ss'
  },
  placeholder: {
    type: String as PropType<string>
  },
  allowClear: {
    type: Boolean as PropType<boolean>,
    default: true
  }
})
const dateValue = ref<string | Dayjs>()
const emit = defineEmits(['update:startTime', 'update:endTime', 'change'])

const modelValue = computed({
  get() {
    return dateValue.value || props.startTime || props.endTime
  },
  set(val) {
    dateValue.value = val ?? undefined
    const startTimeValue = val ? dayjs(val).startOf('month').format(props.valueFormat) : undefined
    const endTimeValue = val ? dayjs(val).endOf('month').format(props.valueFormat) : undefined
    emit('update:startTime', startTimeValue)
    emit('update:endTime', endTimeValue)
  }
})
const handleChange = (value: string | Dayjs) => {
  modelValue.value = value
  emit('change', value)
}
</script>
<script lang="ts">
export default { name: 'CosRangePickerMonth' }
</script>

<style scoped></style>
